import { AxiosError } from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import {
  useAlertMessage,
  useNotification,
  useResource,
} from '@bom-nextgen-keycloak/web/core';
import {
  ErrorMessage,
  fetchUserDetail,
  QUERY_KEY,
  updateUser,
} from '@bom-nextgen-keycloak/web/shared/data-access';
import { PARENT_PATH } from '../shared';

export const useUserDetail2 = (userId: string) => {
  const defaultData = null;
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { groupId } = useResource();
  const { setAlertMessage } = useAlertMessage();
  const { setNotification } = useNotification();

  const queryKeys = [QUERY_KEY.USER_DETAIL, userId];

  const { data = defaultData, isLoading } = useQuery(
    queryKeys,
    () => fetchUserDetail(userId, groupId),
    {
      onError: (error: AxiosError<ErrorMessage>) => {
        const message =
          error.response?.data.message || 'Cannot get user detail';

        setAlertMessage({
          message,
          statusCode: error.response?.status,
          typeStatusMessage: 'error',
        });

        navigate(PARENT_PATH);
      },
      staleTime: 5 * 1000,
    }
  );

  const updateMutation = useMutation(updateUser, {
    onError: (error: AxiosError<ErrorMessage>) => {
      const message = error.response?.data.message || 'Cannot update user';

      setAlertMessage({
        message,
        statusCode: error.response?.status,
        typeStatusMessage: 'error',
      });
    },
    onSuccess: () => {
      setNotification({
        message: 'User updated',
        type: 'success',
      });
      handleReload();
    },
  });

  const handleReload = () => {
    queryClient.invalidateQueries(queryKeys);
  };

  return {
    data,
    isLoading,
    handleReload,
    updateMutation,
  };
};
